import React, { useState, useEffect } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';

import CommonTable from '../../CommonTable/CommonTable';
import Link from '../../Link/Link';
import CustomPagination from '../../CustomPagination/CustomPagination';
import Loader from '../../Loader/Loader';

import { updateMobileLanguageStatus, updateDefaultMobileLanguage } from '../../../actions/siteadmin/MobileLanguage/updateMobileLanguage';

import showToaster from '../../../helpers/toasterMessages/showToaster';
import { demoRestrictionEncode } from '../../../helpers/DemoRestriction/demoRestriction';

import messages from '../../../locale/jsonMessages';

import { withQuery } from '../../../hoc/withGraphql';
import { getAllMobileLanguage } from '../../../lib/graphql';
import debounce from '../../../helpers/debounce';
import { manageAndroidMobileLanguage, manageFlutterMobileLanguage, manageiOSMobileLanguage } from '../../../config';

import cs from '../../../components/commonStyle.css';
import s from './MobileLanguageInfo.css';


function MobileLanguageInfo(props) {
  const {
    data: { getAllMobileLanguage = {}, refetch, loading }, appType
  } = props;

  const [isRestrict, setIsRestrict] = useState(false);
  const [searchList, setSearchList] = useState('');
  const [languageStatus, setLanguageStatus] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    async function fetchData() {
      const isRestrict = await dispatch(demoRestrictionEncode({}));
      if (isRestrict) {
        setIsRestrict(isRestrict);
      }
    }
    fetchData()
  }, []);

  const intl = useIntl();
  const dispatch = useDispatch();
  const handleSearchChange = debounce((value) => {
    const variables = {
      currentPage: 1,
      appType,
      searchList: value,
      isEnable: languageStatus === '' ? undefined : languageStatus === 'true'
    };
    setCurrentPage(1);
    setSearchList(value);
    refetch(variables);
  }, 300);

  const handleDefault = async (id) => {
    if (isRestrict) {
      showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
      return;
    }
    const pageFix = currentPage > 1 && getAllMobileLanguage?.results?.length === 1 ? currentPage - 1 : currentPage;
    const isSuccess = await dispatch(updateDefaultMobileLanguage(id));
    if (isSuccess) {
      const variables = {
        currentPage: pageFix,
        appType,
        searchList,
        isEnable: languageStatus === '' ? undefined : languageStatus === 'true'
      };
      setCurrentPage(pageFix);
      await refetch(variables);
    }
  };

  const paginationData = (newPage) => {
    const variables = {
      currentPage: newPage,
      appType,
      searchList,
      isEnable: languageStatus === '' ? undefined : languageStatus === 'true'
    };
    setCurrentPage(newPage);
    refetch(variables);
  };

  const handleUpdateStatus = async (id, isEnable) => {
    if (isRestrict) {
      showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
      return;
    }
    const pageFix = currentPage > 1 && getAllMobileLanguage?.results?.length === 1 ? currentPage - 1 : currentPage;
    const isSuccess = await dispatch(updateMobileLanguageStatus(id, isEnable));
    if (isSuccess) {
      const variables = {
        currentPage: pageFix,
        appType,
        searchList,
        isEnable: languageStatus === '' ? undefined : languageStatus === 'true'
      };
      setCurrentPage(pageFix);
      await refetch(variables);
    }
  }

  const languageSatusFilter = [
    { value: '', label: intl.formatMessage(messages.claimAll) },
    { value: "true", label: intl.formatMessage(messages.activeLabel) },
    { value: "false", label: intl.formatMessage(messages.inActiveLabel) }
  ]

  const handleFilterChange = (event) => {
    const selectedValue = event?.target?.value ?? '';
    setLanguageStatus(selectedValue)
    const parsedStatus = selectedValue === '' ? undefined : selectedValue === 'true';
    const variables = {
      currentPage: 1,
      appType,
      searchList,
      isEnable: parsedStatus
    };
    setSearchList(searchList);
    setCurrentPage(1);
    refetch(variables);
  }

  const thead = () => [
    { data: intl.formatMessage(messages.idLabel) },
    { data: intl.formatMessage(messages.language) },
    { data: intl.formatMessage(messages.languageCode) },
    { data: intl.formatMessage(messages.default) },
    { data: intl.formatMessage(messages.setEnableDisable) },
    manageAndroidMobileLanguage === "true" && { data: intl.formatMessage(messages.androideditLabel) },
    manageiOSMobileLanguage === "true" && { data: intl.formatMessage(messages.iosEditLabel) },
    manageFlutterMobileLanguage === "true" && { data: intl.formatMessage(messages.flutterEditLabel) },
    { data: intl.formatMessage(messages.manageWebLanguage) },
  ];
  const tbody = () =>
    getAllMobileLanguage?.results?.map((value, key) => ({
      id: key,
      data: [
        { data: value?.id },
        { data: value?.language },
        { data: value?.languageCode },
        {
          data: !value?.isActive ? (
            <div>
              <Link noLink onClick={() => handleDefault(value?.id)}>
                <FormattedMessage  {...messages.setAsDefault} />
              </Link>
            </div>
          ) : '-'
        },
        {
          data: <div>
            <select className='commonTableInsideSelect' value={value?.isEnable} onChange={(e) => handleUpdateStatus(value?.id, value?.isEnable)}>
              <option value={true}>{intl.formatMessage(messages.activeLabel)}</option>
              <option value={false}>{intl.formatMessage(messages.inActiveLabel)}</option>
            </select>
          </div>
        },
        manageAndroidMobileLanguage === "true" && {
          data:
            <div ><Link to={`/siteadmin/mobile-language/android_app/edit/${value?.languageCode}`}>
              <FormattedMessage  {...messages.editLabel} />
            </Link></div >
        },
        manageiOSMobileLanguage === "true" && {
          data:
            <div ><Link to={`/siteadmin/mobile-language/iOS_app/edit/${value?.languageCode}`}>
              <FormattedMessage  {...messages.editLabel} />
            </Link></div >
        },
        manageFlutterMobileLanguage === "true" && {
          data:
            <div ><Link to={`/siteadmin/mobile-language/flutter_app/edit/${value?.languageCode}`}>
              <FormattedMessage  {...messages.editLabel} />
            </Link></div >
        },
        {
          data:
            <div ><Link to={`/siteadmin/mobile-language/web/edit/${value?.languageCode}`}>
              <FormattedMessage  {...messages.editLabel} />
            </Link></div >
        },
      ]
    }));
  return (
    <div>
      {loading && <div><Loader type={"text"} /></div>}

      {!loading && <div>
        <CommonTable
          thead={thead}
          tbody={tbody}
          filterOption={languageSatusFilter}
          filterValue={languageStatus}
          handleFilter={handleFilterChange}
          title={intl.formatMessage(messages.mobileLanguagePageTitle)}
          isSearch
          onSearch={(e) => (handleSearchChange(e?.target?.value))}
        />
        {getAllMobileLanguage?.count > 0 && (
          <CustomPagination
            total={getAllMobileLanguage?.count}
            currentPage={currentPage}
            defaultCurrent={1}
            defaultPageSize={10}
            change={paginationData}
            paginationLabel={intl.formatMessage({ id: getAllMobileLanguage?.count > 1 ? 'languages' : 'language' })}
            isScroll
          />
        )}
      </div>}
    </div>
  );
}

export default withQuery(getAllMobileLanguage, {
  options: (props) => ({
    variables: {
      currentPage: props.currentPage,
      appType: props.appType,
      searchList: props.searchList,
      isEnable: props.isEnable
    },
    fetchPolicy: 'network-only',
    ssr: false
  })
})(withStyles(cs, s)(MobileLanguageInfo));
